interface IProps {
    color?: string;
}

export const ShareIcon = (props: IProps) => {
    const { color } = props;
    return (
        <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_715_16111)">
                <path d="M12.6875 10.875C11.7612 10.875 10.945 11.3307 10.4323 12.0236L5.99969 9.75387C6.07328 9.50303 6.125 9.24306 6.125 8.96875C6.125 8.59669 6.04872 8.24297 5.91694 7.91762L10.5558 5.12612C11.0721 5.732 11.8309 6.125 12.6875 6.125C14.2384 6.125 15.5 4.86341 15.5 3.3125C15.5 1.76159 14.2384 0.5 12.6875 0.5C11.1366 0.5 9.875 1.76159 9.875 3.3125C9.875 3.66991 9.94859 4.00894 10.0707 4.32369L5.41797 7.12337C4.90216 6.5355 4.15428 6.15625 3.3125 6.15625C1.76159 6.15625 0.5 7.41784 0.5 8.96875C0.5 10.5197 1.76159 11.7812 3.3125 11.7812C4.25406 11.7812 5.08409 11.3122 5.59484 10.5998L10.0128 12.8622C9.93147 13.1248 9.875 13.3984 9.875 13.6875C9.875 15.2384 11.1366 16.5 12.6875 16.5C14.2384 16.5 15.5 15.2384 15.5 13.6875C15.5 12.1366 14.2384 10.875 12.6875 10.875Z"
                    fill={color || "#336C51"} />
            </g>
            <defs>
                <clipPath id="clip0_715_16111">
                    <rect width="16" height="16" fill="white" transform="translate(0 0.5)" />
                </clipPath>
            </defs>
        </svg>

    );
};

